
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, Button, DataGrid, Popup, ScrollView, SelectBox } from 'devextreme-react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog, openItemDialog, setItemTypeId } from '../../store/item/itemDialogReducer'
import { store } from '../../services/store';
import uri from '../../utils/uri';
import { createCustomStore, createStore } from '../../utils/proxy';
import Form, { EmptyItem, GroupItem, Item, Label, RequiredRule, SimpleItem, StringLengthRule } from 'devextreme-react/form';
import http from '../../utils/http';
import notify from 'devextreme/ui/notify';
import { closeThisDialog } from '../../store/dialog/dialogReducer';
import DataSource from 'devextreme/data/data_source';
import { Column, Editing, Lookup } from 'devextreme-react/data-grid';
import ArrayStore from 'devextreme/data/array_store';



const defualtItem = {
  name: null,
  entries: [],
  catalogs: [],
};


const AddCatalogEntryDialog = (props) => {

  const { updateParent } = props;

  let dispatch = useDispatch();
  const [item, setItem] = useState(defualtItem);
  const { dialog } = useSelector((store) => store);

  const formRef = useRef();

  const onLoad = (name) => {
    Promise.all([
      http(uri.catalogEntries(name)).asGet(),
      http(uri.catalogEntriesSearch).asGet()
    ]).then(result => {
       setItem({
        ...item,
        name: name,
        entries: [...result[0]],
        catalogs: result[1]
      });
    });
  }

  const loadCatalogs = () => {

    Promise.all([
      http(uri.catalogEntriesSearch).asGet()
    ]).then(result => {

      setItem(prev => {
        return {
          ...prev,
          names: [...new Set(result[0].map(x => x.catalog))],
          catalogs: result[0]
        }
      });

    });
  }


  useEffect(() => {

    if (dialog.id != null && dialog.id != '') {

      onLoad(dialog.id);
    } else {
      setItem({ ...defualtItem });
      //Cargar Catalogos
  
      loadCatalogs();
    }
  }, [dialog.id]);

  let editable = true;

  const guardarItem = (params) => {

    notify('Datos guardados correctamente');
        dispatch(closeThisDialog());
        updateParent();
        setItem({ ...defualtItem });
  }

  const nameChanged = ({ value }) => {
    setItem(prev => {
      return {
        ...prev,
        name:value
      }
    });
}

return (
  <Popup width={900} minHeight={475} title={`${item.name == null ? 'Agregar' : 'Editar'} Catalogo`} visible={dialog.open} onHiding={() => { dispatch(closeThisDialog()); setItem({ ...defualtItem });updateParent(); }}>
    <ScrollView showScrollbar="onScroll">
      <Form formData={item} ref={formRef}>
        <GroupItem cssClass="second-group" colCount={2}>
          <SimpleItem dataField="name" editorOptions={{ onValueChanged: nameChanged}}>
            <Label text="Catalogo" />
            <RequiredRule message="Este campo es requerido" />
            <StringLengthRule max={50} message="Maximo 50 caracteres" />
          </SimpleItem>
          <EmptyItem></EmptyItem>
        </GroupItem>

        <GroupItem caption="Valores">
          <DataGrid width="100%" dataSource={item.name==null? null: store({ uri: { get: uri.catalogEntries(item.name), insert: uri.catalogEntries(item.name) } })}  >
            <Editing
              allowUpdating={true}
              allowDeleting={true}
              allowAdding={item.name != null && item.name != ''}
              useIcons={true}
            >
            </Editing>
            <Column dataField="id" caption="Id" width={60} visible={true} allowEditing={false} />
            <Column dataField="value" caption="Valor" >
              <RequiredRule message="Este campo es requerido" />
            </Column>
            <Column dataField="parentId" caption="Dependencia Padre"  >
              <Lookup dataSource={item.catalogs}
                grouped={true}
                showClearButton={true}
                valueExpr="id"
                displayExpr="value" />
            </Column>
          </DataGrid>
        </GroupItem>

      </Form>
      <br />
      <Button
        width={180}
        text="Cerrar"
        type="default"
        icon='save'
        onClick={guardarItem}
      />
      <br />

    </ScrollView>
  </Popup>

);
};


AddCatalogEntryDialog.propTypes = {

};


export default AddCatalogEntryDialog;
